export const cssFromStylesObject = (styles = {}) => {
    let css = ''

    for (let style in styles) {
        css += `${style}:${styles[style]};`
    }

    return css
}
